export default function({ app, store, route, redirect, $config, query }) {
  // console.log(`middleware pageQueryString $config=`, $config)
  if (!$config.OptionsAddQueryStringToURLEnabled) {
    console.log(`middleware pageQueryString DO NOTHING`)
    store.commit('s/pageQueryParams', {})
    return
  }
  console.log(`middleware pageQueryString query=`, query)
  if (query[$config.OptionsAddQueryStringToURLKey] !== undefined) {
    const queryParams = {}
    queryParams[$config.OptionsAddQueryStringToURLKey] = query[$config.OptionsAddQueryStringToURLKey]
    console.log(`middleware UPDATE pageQueryParams=`, queryParams)
    console.log(`middleware UPDATE  store.state=`, store.state)
    store.state.s.pageQueryParams = {}
    store.commit('s/pageQueryParams', queryParams)
    console.log(`middleware UPDATE  store.state=`, store.getters['s/pageQueryParams'])
  } else {
    store.commit('s/pageQueryParams', {})
  }
}
